import React from 'react';
import {
  Container,
  SectionTitleWithIcon,
  CommentIconWrapper,
  CommentText,
  ThumbnailGrid,
  Thumbnail,
  ReplyButton,
} from './CommentSection.styled';
import { CommentIcon } from '../../../../components/Icons';
import type { ImageWithDate } from '../../../../types/contactLog';

interface Photo {
  photo_id: string;
  s3_key: string;
}

interface PhotoViewUrl {
  s3_key: string;
  view_url: string;
  error?: string;
}

interface CommentSectionProps {
  facilityName: string;
  commentMessage?: string;
  photos?: Photo[];
  photoViewUrls?: PhotoViewUrl[];
  images: ImageWithDate[];
  onThumbnailClick: (imageIndex: number) => void;
  onReplyClick?: () => void;
}

const CommentSectionComponent = React.forwardRef<HTMLDivElement, CommentSectionProps>(({
  facilityName,
  commentMessage,
  photos,
  photoViewUrls,
  images,
  onThumbnailClick,
  onReplyClick,
}, ref) => {
  return (
    <Container ref={ref}>
      <SectionTitleWithIcon>
        <CommentIconWrapper><CommentIcon /></CommentIconWrapper>
        {facilityName}のコメント
      </SectionTitleWithIcon>
      {commentMessage ? (
        <>
          <CommentText>{commentMessage}</CommentText>
          {photos && photos.length > 0 && (
            <ThumbnailGrid>
              {photos.map((photo) => {
                const photoUrl = Array.isArray(photoViewUrls)
                  ? photoViewUrls.find((urlData) => urlData.s3_key === photo.s3_key)
                  : undefined;

                return (
                  <Thumbnail
                    key={photo.photo_id}
                    $imageUrl={photoUrl?.view_url}
                    onClick={() => {
                      const imageIndex = images.findIndex(img => img.url === photoUrl?.view_url);
                      if (imageIndex >= 0) {
                        onThumbnailClick(imageIndex);
                      }
                    }}
                  >
                    {!photoUrl?.view_url && '📷'}
                  </Thumbnail>
                );
              })}
            </ThumbnailGrid>
          )}
          {onReplyClick && (
            <ReplyButton onClick={onReplyClick}>
              返信する
            </ReplyButton>
          )}
        </>
      ) : (
        <CommentText>本日の連絡帳コメントはまだありません。</CommentText>
      )}
    </Container>
  );
});

// React.memoで最適化: propsが変わらない限り再レンダリングしない
export const CommentSection = React.memo(CommentSectionComponent);

export default CommentSection;
